import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '../commons/abstract.service';
import { SettingsWebhook } from '../models/settings-webhook.model';

@Injectable({ providedIn: 'root' })
export class SettingsWebhookService extends AbstractService<SettingsWebhook> {

  getURLBase(): string {
    return '/settings-webhook';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: SettingsWebhook): void {
    delete obj?._id;
  }

  preUpdate(obj: SettingsWebhook): void {
  }

  getByChannel(idChannel: string): Observable<SettingsWebhook> {
    return super.get(`/find/channel/${idChannel}`);
  }

  getByCompany(idCompany: string): Observable<Array<SettingsWebhook>> {
    return super.get(`/find/company/${idCompany}`);
  }

}
